var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "py-3" }, [
    _vm.userRewards && _vm.userRewards.length
      ? _c(
          "div",
          [
            _vm._l(_vm.userRewards, function(userReward, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "no-style",
                      attrs: { to: "/user-rewards/" + userReward.id }
                    },
                    [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body p-3" }, [
                          _c("div", { staticClass: "d-flex align-items-top" }, [
                            _c("div", { staticClass: "pr-3" }, [
                              _c("img", {
                                staticClass: "rounded",
                                attrs: {
                                  height: "72",
                                  src: userReward.reward.image_url
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-fill" }, [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge text-badge-small badge-pill py-1 px-2",
                                    class: _vm.getUserRewardStatus(userReward)
                                      .cssClass
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.getUserRewardStatus(userReward)
                                            .text
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "pt-2" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$i18n.locale === "th"
                                        ? userReward.reward.title_th
                                        : userReward.reward.title_en
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              userReward.expire_date
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pt-2 text-secondary text-remark"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("message.rewards.expired_on")
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("prettyOnlyDate")(
                                              userReward.expire_date
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          userReward.reward.delivery_info_type &&
                          !userReward.delivery_info
                            ? _c(
                                "div",
                                { staticClass: "text-right" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-outline-info btn-sm",
                                      attrs: {
                                        to:
                                          "/user-rewards/" +
                                          userReward.id +
                                          "/delivery-info"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.rewards.add_delivery_info"
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.canLoadMore
              ? _c("div", { staticClass: "text-center" }, [
                  _vm.isMore
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-block btn-info",
                          attrs: { disabled: _vm.isLoadingMore },
                          on: {
                            click: function($event) {
                              return _vm.fetchMore()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.isLoadingMore
                                  ? _vm.$t("message.button.loading")
                                  : _vm.$t("message.button.load_more")
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ],
          2
        )
      : _c(
          "div",
          { staticClass: "p-4 row text-center" },
          [
            _vm.isLoading
              ? _c("loader")
              : _c("div", { staticClass: "col-12" }, [
                  _c("h3", [
                    _c("i", {
                      staticClass: "fas fa-exclamation-triangle -status-pending"
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("message.rewards.no_redeemed_reward_remark")
                        ) +
                        "\n      "
                    )
                  ])
                ])
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77433f69", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77433f69","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/UserRewards.vue
// module id = 2315
// module chunks = 0